export default "__VITE_ASSET__2ufftbk8__"